import { schema } from "normalizr";

export const servicePreviewSchema = new schema.Entity("servicePreviews");
export const serviceSchema = new schema.Entity("services");